import React, { useState, useEffect } from 'react'
import Form from './Form'

/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
// to eliminate prop spreading on the IMaskInput component, one would have to include
// at least 20 or 30 properties to pass in
// easier to just override the no prop spreading rule for such a trivial component

export const EditAccountManager = ({
  dispatch, userObj, t, updateUser
}) => {
  const [showEditAccount, setShowEditAccount] = useState(false)
  const [showProfileInfo, setShowProfileInfo] = useState(true)
  const [alertVisible, setAlertVisible] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')

  const [userFields, setUserFields] = useState({
    email: userObj.email ?? '',
    secondEmail: userObj.secondEmail ?? '',
  })
  const [validFields, setValidFields] = useState({
    email: { isValid: true, hasError: false },
    secondEmail: { isValid: true, hasError: false },
  })
  const [isFormValid, setIsFormValid] = useState(true)

  const toggleEditAccount = () => {
    setShowEditAccount(!showEditAccount)
    setShowProfileInfo(!showProfileInfo)

    setUserFields({
      email: userObj.email ?? '',
      secondEmail: userObj.secondEmail ?? '',
    })

    setValidFields({
      email: { isValid: true, hasError: false },
      secondEmail: { isValid: true, hasError: false },
    })
  }

  const validateRegex = (field, newValue) => {
    const regexStrings = {
      email: /^(\S+@\S+\.\S+)$/,
      secondEmail: /^$|(\S+@\S+\.\S+)$/,
    }

    return regexStrings[field].test(newValue)
  }

  const validateChange = (field, newValue) => {
    setUserFields({ ...userFields, [field]: newValue })
    const nonRequiredFields = ['secondEmail']
    if (nonRequiredFields.includes(field) && (!newValue || newValue.trim() === '')) {
      setValidFields((prev) => ({ ...prev, [field]: { isValid: true, hasError: false } }))
      return
    }
    const regexFields = ['email', 'secondEmail']
    setValidFields((prev) => {
      if (regexFields.includes(field)) {
        const regexIsValid = validateRegex(field, newValue)
        return { ...prev, [field]: { isValid: regexIsValid, hasError: false } }
      }
      if (newValue && newValue.trim() !== '') {
        return { ...prev, [field]: { isValid: true, hasError: false } }
      }
      return { ...prev, [field]: { isValid: false, hasError: false } }
    })
  }

  const handleBlur = (field) => {
    if (!validFields[field].isValid) {
      setValidFields((prev) => ({ ...prev, [field]: { isValid: false, hasError: true } }))
    }
  }

  useEffect(() => {
    setIsFormValid(Object.values(validFields).every((field) => field.isValid))
  }, [validFields])

  const handleSubmit = () => {
    const formattedUserFields = {
      ...userFields,
    }

    const payload = Object.fromEntries(
      Object.entries(formattedUserFields).filter(([key, value]) => {
        const original = userObj[key]
        const isUnchanged = String(value) === String(original)

        return !isUnchanged
      })
    )

    dispatch(updateUser(payload))
      .unwrap()
      .then(() => {
        setShowEditAccount(false)
      })
      .catch(() => {
        setAlertMessage(t('error-saveFailed'))
        setAlertVisible(true)
      })
  }

  const handleEditAccountError = (errorMessage) => {
    setAlertMessage(errorMessage)
    setAlertVisible(true)
  }

  const editAccountComponent = showEditAccount && (
    <Form
      t={t}
      userFields={userFields}
      validFields={validFields}
      validateChange={validateChange}
      handleBlur={handleBlur}
      handleSubmit={handleSubmit}
      isFormValid={isFormValid}
      onCancel={toggleEditAccount}
      onError={handleEditAccountError}
      setUserFields={setUserFields}
    />
  )

  return {
    editAccountComponent,
    setAlertVisible,
    showEditAccount,
    toggleEditAccount,
    handleSubmit,
    userFields,
    validFields,
    validateChange,
    handleBlur,
    isFormValid,
    setUserFields,
    showProfileInfo
  }
}
